import { render, staticRenderFns } from "./import_pdfs_done.vue?vue&type=template&id=28985e0e&scoped=true&"
import script from "./import_pdfs_done.vue?vue&type=script&lang=js&"
export * from "./import_pdfs_done.vue?vue&type=script&lang=js&"
import style0 from "./import_pdfs_done.vue?vue&type=style&index=0&id=28985e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28985e0e",
  null
  
)

export default component.exports